import { SecureStorage } from '@aparajita/capacitor-secure-storage'

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * Token storage service using secure storage (Keychain on iOS, KeyStore on Android)
 * For web development, falls back to localStorage
 */
export const tokenStorage = {
  /**
   * Save both access token and refresh token to secure storage
   * @param {string} accessToken - Short-lived access token
   * @param {string} refreshToken - Long-lived refresh token
   */
  async saveTokens(accessToken, refreshToken) {
    const timestamp = new Date().toISOString();
    console.log(`💾 SAVING TOKENS at ${timestamp}`);
    console.log(`💾 Access token length: ${accessToken?.length}`);
    console.log(`💾 Refresh token length: ${refreshToken?.length}`);
    await SecureStorage.set(TOKEN_KEY, accessToken);
    await SecureStorage.set(REFRESH_TOKEN_KEY, refreshToken);
    console.log(`💾 Tokens saved successfully at ${timestamp}`);
  },

  /**
   * Retrieve the access token from secure storage
   * @returns {Promise<string|null>} Access token or null if not found
   */
  async getAccessToken() {
    try {
      const token = await SecureStorage.get(TOKEN_KEY);
      if (!token) {
        console.warn('⚠️ Access token is null/empty');
      }
      return token;
    } catch (error) {
      // Key doesn't exist
      console.warn('❌ Access token not found in storage');
      return null;
    }
  },

  /**
   * Retrieve the refresh token from secure storage
   * @returns {Promise<string|null>} Refresh token or null if not found
   */
  async getRefreshToken() {
    try {
      const token = await SecureStorage.get(REFRESH_TOKEN_KEY);
      if (!token) {
        console.warn('⚠️ Refresh token is null/empty');
      }
      return token;
    } catch (error) {
      // Key doesn't exist
      console.warn('❌ Refresh token not found in storage');
      return null;
    }
  },

  /**
   * Clear both tokens from secure storage (used on logout or auth failure)
   */
  async clearTokens() {
    // Get stack trace to understand WHERE this was called from
    const stack = new Error().stack;
    console.log('🧹 CLEARING TOKENS - Called from:', stack);

    try {
      await SecureStorage.remove(TOKEN_KEY)
      console.log('🧹 Access token removed from storage');
    } catch (error) {
      // Key doesn't exist, ignore
      console.log('⚠️ Access token was already missing');
    }
    try {
      await SecureStorage.remove(REFRESH_TOKEN_KEY)
      console.log('🧹 Refresh token removed from storage');
    } catch (error) {
      // Key doesn't exist, ignore
      console.log('⚠️ Refresh token was already missing');
    }
  }
}
